import { API_URL_PROJECT } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getProjects = () =>
  apiInstance({
    url: API_URL_PROJECT + "list",
    params: {
      limit: 20000,
    },
  });

export default getProjects;
